import React  from 'react';
import {InputBarBlock, ProfileImageArea, CurrentUserProfileImg, InputForm, TextArea, TextInput, SubmitButton,DisabledSubmitButton } from './style';
 
import { useSelector } from 'react-redux';
import constants from 'utils/constants'

const BottomTextArea = ({isValid, displayType, onSubmit, onChange,totalAreaRef, textAreaRef,onHeightChange, textValue, setBottomInputFocus, onFocus}) => {
    const userInfo = useSelector((state) => {
        return state.userInfo;
    });
    const userImg = (userInfo)
        ?`${constants['imagePath']}/user_profile_img/${userInfo['profile_img']}` 
        : `${constants['imagePath']}/user_profile_img/default_profile_1.png`;
    return (
        <InputBarBlock displayType={displayType} ref={totalAreaRef}>
            <ProfileImageArea>
                <CurrentUserProfileImg src={userImg}/>
            </ProfileImageArea>
            <InputForm>
                <TextArea>
                    <TextInput 
                        value={textValue}
                        onChange={(e) =>{
                            if(onChange) onChange(e);
                        }}
                        ref={textAreaRef} 
                        placeholder={'댓글을 달아주세요 :)'}
                        onBlur={() => setBottomInputFocus(false)}
                        onFocus={()=>{if(onFocus)onFocus()}}
                        />
                </TextArea>
                {
                    (isValid?(<SubmitButton onClick={(e)=>{
                        if(onSubmit) onSubmit();
                        }}>작성
                        </SubmitButton>)
                    :(<DisabledSubmitButton >작성</DisabledSubmitButton>)
                    )
                }
            </InputForm>
        </InputBarBlock>
    )
}

export default BottomTextArea;